import React from 'react';
interface DefectHighlightProps {
  /** 0 = Shape, 1 = Position, 2 = Flash, null = nothing highlighted */
  cue: number | null;
}

/** Single marker position on the still. */
const MARKER = {
  x: 58,
  y: 40
};

/**
 * Highlights the defect category currently being called out on the still.
 */
export function DefectHighlight({
  cue
}: DefectHighlightProps) {
  const active = cue !== null;
  return <div className="pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-50" data-mp="21g8vukdbq7wx">
      <span className={`absolute -translate-x-1/2 -translate-y-1/2 transition-all duration-300 ${active ? 'scale-100 opacity-100' : 'scale-75 opacity-0'}`} style={{
      left: `${MARKER.x}%`,
      top: `${MARKER.y}%`
    }} data-id="element-51" data-mp="25idnxeo4iwhg">
        <span className="relative block h-16 w-16" data-id="element-52" data-mp="1wi7crzfwe8lg">
          <span className="absolute inset-0 rounded-full border-2 border-dashed border-solventum-primary" data-id="element-53" data-mp="3lwvff8yosc6a" />
          <span className="absolute inset-0 animate-ping rounded-full border border-solventum-primary/40" data-id="element-54" data-mp="3qw8aui3mirkh" />
        </span>
      </span>
    </div>;
}